import { render, staticRenderFns } from "./LanguagesConfiguration.vue?vue&type=template&id=0729abde&scoped=true"
import script from "./LanguagesConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguagesConfiguration.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LanguagesConfiguration.vue?vue&type=style&index=0&id=0729abde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0729abde",
  null
  
)

export default component.exports